const getSelectedElement = (element) => {
    const originalElement = element.target.originalElement
    const selectedElement = element.selected._element.currentSrc
    const defaultEvent = element
    const cropProperty = element.target.cropProperty
        ? element.target.cropProperty
        : {}
    const width = element.target.width - 10
    const height = element.target.height - 10
    const activeSelection = element.target
    return {
        originalElement,
        selectedElement,
        defaultEvent,
        cropProperty,
        width,
        height,
        activeSelection
    }
}

const setOriginalElement = (e) => {
    e.target.originalElement = e.selected._element.currentSrc
}

const isImageSelected = (element) => {
    return element.selected._element?.nodeName === 'IMG'
}

const isImage = (obj) => {
    return obj._element?.nodeName === 'IMG'
}

export { getSelectedElement, isImageSelected, isImage, setOriginalElement }
